require("./bootstrap");
require("./main-navigation");
require("./carousel");
require("./video");
require("./backend");

// Helpers
require("./helpers/constants");
require("./helpers/media-query");
require("./helpers/shortcuts");

// Effects
require("./effects/parallax");
require("./effects/scroll-sideways");
require("./effects/scroll-snap");
require("./effects/slide");

// Templates
require("./templates/content-columns");
require("./templates/product");
require("./templates/product-category");
require("./templates/master");
require("./templates/articles");
require("./templates/support-downloads");
require("./templates/marketing-directory");
